const Avatar = ({ src, size = 26, shape = 'square', onClick }) => (
  <img src={src} alt='avatar' width={size} height={size} className={`avatar ${shape}`} onClick={() => (onClick ? onClick() : {})} loading='lazy' />
);

export default Avatar;
